<template>
  <div>
    <content-loader v-if="$apollo.loading" title="job details" />
    <div v-else>
      <div class="container-fluid-xl">
        <div class="blank-space"></div>
        <div class="container job-detail">
          <div>
            <div class="row top-header">
              <div class="company-details d-flex flex-row">
                <img :src="job.company_image" />
                <div class="d-flex flex-column mt-3">
                  <div class="cs-textstyle-section-heading">{{ job.name }}</div>
                  <div class="cs-textstyle-paragraph">
                    {{ job.company_name }}
                    <span class="time-text"
                      >• {{ job.created_at | moment('from') }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row mt-3 mr-2">
                <div>
                  <cs-button
                    variant="primary"
                    :href="job.link"
                    corners="rounded"
                    target="_blank"
                    >Apply for this job</cs-button
                  >
                </div>
              </div>
            </div>
            <div class="job-specs d-flex flex-column mt-3">
              <div class="d-flex flex-row">
                <i class="cs-icons-marker mr-2"></i
                ><span class="cs-textstyle-paragraph-bold">Location</span>
              </div>
              <div class="cs-textstyle-paragraph muted-text">
                {{ job.location || 'Remote' }}
              </div>
            </div>
            <div>
              <div class="cs-textstyle-item-heading my-3">Job Overview</div>
              <div v-html="job.description_html"></div>
            </div>
            <div>
              <div class="cs-textstyle-section-heading mt-4 mb-3">
                More Jobs
              </div>
              <div class="jobs">
                <div v-for="job in filteredJobs.slice(0, 3)" :key="job.id">
                  <app-job-card
                    :job="job"
                    card-border
                    @click="onOpenJobDetails(job)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetJob from '@/newgql/GetJob.gql';
import CompanyCard from '@/components/company/CompanyCard';
import ContentLoader from '@/components/global/ContentLoader';
import PageHeader from '@/components/global/PageHeader';
import MemberInfoCard from '@/components/global/MemberInfoCard';
import ListRecentJobs from '@/newgql/ListRecentJobs.gql';
import AppJobCard from '@/components/jobs/JobCard';

export default {
  name: 'JobDetail',

  components: {
    AppJobCard,
    PageHeader,
    CompanyCard,
    ContentLoader,
    MemberInfoCard
  },

  apollo: {
    jobs: ListRecentJobs,
    job: {
      query: GetJob,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  computed: {
    filteredJobs() {
      return this.jobs.filter(job => {
        return job.id !== this.job.id;
      });
    }
  },
  methods: {
    onOpenJobDetails(job) {
      this.$router.push({ name: 'JobDetail', params: { id: job.id } });
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  margin: 10px;
}

img {
  height: 90px;
  width: 90px;
  border-radius: 50%;
  margin-left: 15px;
  margin-right: 16px;
}

.muted-text {
  color: var(--cs-gray-05);
}

.time-text {
  color: var(--cs-gray-04);
}

i {
  font-size: 18px;
  color: $primary;
  margin-bottom: 8px;
}

.btn {
  border-radius: 5px;
}

.top-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  @include media-breakpoint-up(md) {
    flex-direction: row;
    justify-content: space-between;
  }
}

.rounded-circle {
  width: 25px;
  height: 25px;
}

.blank-space {
  display: none;
  @include media-breakpoint-up(md) {
    display: block;
    height: 22rem;
    background-color: $primary;
  }
}

.job-detail {
  padding: 30px;
  margin-bottom: 60px;
  @include media-breakpoint-up(md) {
    display: flex;
    margin-top: -17rem;
    background: #fff;
    border-radius: 5px;
  }
}

.job-specs {
  border-bottom: 1px solid var(--cs-gray-02);
  padding-bottom: 29px;
}

.jobs {
  display: grid;
  grid-gap: 1rem;
  @include media-breakpoint-up(md) {
    grid-template-columns: repeat(2, 1fr);
  }
  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 767px) {
  .job-detail {
    margin-top: 65px;
  }
}
</style>
